import { createFileRoute } from '@tanstack/react-router';

import terms from '../content/terms.md?raw';
import { LegalPage } from '../pages/LegalPage';

export const Route = createFileRoute('/legal/terms')({
  component: () => <LegalPage markdown={terms} title="Terms of Use" />,
});
